export default "__VITE_ASSET__OB1pcGYP__"